import { StorageMethods, StoragePairs, StorageState } from '@djs';
import { localStorage } from '@vkontakte/vkjs';

// используем абстракцию localStorage из vkjs, так как в ней есть фоллбек на локальный объект,
// если localStorage не поддерживается (например, в инкогнито)

export class LocalStorageMethods<T extends StorageState> implements StorageMethods<T> {
  public async set<K extends keyof T>(pairs: StoragePairs<T, K>): Promise<StoragePairs<T, K>> {
    const result: StoragePairs<T, K> = [];

    pairs.forEach(({ key, value }) => {
      try {
        localStorage.setItem(String(key), JSON.stringify(value));
        result.push({ key, value });
      } catch {}
    });

    return result;
  }

  public async get<K extends keyof T>(keys: K[]) {
    const result: StoragePairs<T, K> = [];

    keys.forEach((key) => {
      try {
        // Eсли запрашиваемый ключ не был получен, то заменится значением по умолчанию в основном модуле storage
        const value = localStorage.getItem(String(key));
        value && result.push({ key, value: JSON.parse(value) });
      } catch {}
    });

    return result;
  }

  public async reset<K extends keyof T>(keys: K[]): Promise<K[]> {
    const result: K[] = [];

    keys.forEach((key) => {
      try {
        // Eсли запрашиваемый ключ не был получен, то заменится значением по умолчанию в основном модуле storage
        localStorage.removeItem(String(key));
        result.push(key);
      } catch {}
    });

    return result;
  }
}
